import type { FaireProductEntity } from "../../entity_types/product";

export const p_jk4m6jeuc7: FaireProductEntity = {
  token: "p_jk4m6jeuc7",
  type: "product",
  name: "Check Gauze Baby Boy Romper",
  brandToken: "b_np5ktd5ja2",
  brandName: "Burt's Bees Baby",
  imageUrl:
    "https://cdn.faire.com/fastly/2c08de67491b8c76e1f4a38ed7456c3dae40c92ea85003143550a591ae12ceb4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0a0bc1f12586aaaca61de6253eb6b82b43f00d782c1b64faa83fab26c59563b4.jpeg",
    "https://cdn.faire.com/fastly/f8c3f3e4542d2c1cc293a356218435e4f1ff4bbcfca2bb23715f6ef7a819f7f5.jpeg",
    "https://cdn.faire.com/fastly/f6807f1e9a3d4a84e1602e54228b11d3512247eda513f589e3b0824dd3893ece.jpeg",
    "https://cdn.faire.com/fastly/ac6a354d9be9862b09bb3fbf6705ee48b4f450fe094cc76321ff42d432b6efcc.jpeg",
  ],
  priceDollars: 11.5,
  description:
    "From Burt's Bees Baby, we present our Check Gauze Baby Boy Romper, a part of our commitment to offering high-quality, sustainable, and naturally comfortable clothing for your little ones. Made from organic cotton, this romper is gentle on your baby's skin, ensuring his comfort and safety. Trust us to provide clothing that not only protects your baby but also the planet, with our eco-friendly materials and packaging.",
  tags: [],
  msrpDollars: 23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:54.575Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
